module.exports = __webpack_public_path__ + "img/img_2_style.d93dcbf8.png";